import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule, MatSelectModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';

import { EmployeeCalendarComponent } from './calendar.component';
import { EmployeeCalendarEventFormDialogComponent } from './event-form/event-form.component';
import { CalendarModule as AngularCalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarService } from '@fuse/services/calendar.service';

import { registerLocaleData } from '@angular/common';

import localeSr from '@angular/common/locales/sr-Latn';
import localeHu from '@angular/common/locales/hu';
import localeEn from '@angular/common/locales/en-GB';
import localeUa from '@angular/common/locales/ru-UA';

const routes = [
    {
        path: 'calendar',
        component: EmployeeCalendarComponent

    }
];

registerLocaleData(localeSr);
registerLocaleData(localeHu);
registerLocaleData(localeEn);
registerLocaleData(localeUa);

@NgModule({
    declarations: [
        EmployeeCalendarComponent,
        EmployeeCalendarEventFormDialogComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        AngularCalendarModule,

        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule,
        MatSelectModule,
        MatTooltipModule,

        AngularCalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
    ],
    providers: [
        CalendarService
    ],
    exports: [
        EmployeeCalendarComponent
    ]
    ,
    entryComponents: [
        EmployeeCalendarEventFormDialogComponent
    ]
})

export class EmployeeCalendarModule {
}
